import React from "react"
import styled, { css } from "styled-components"

type FlexAligment = "center" | "flex-end" | "flex-start" | "stretch"
type FlexJustify =
  | FlexAligment
  | "space-around"
  | "space-between"
  | "space-evenly"
type FlexDirection = "row" | "column" | "row-reverse" | "column-reverse"

type BaseFlexProps = {
  alignItems?: FlexAligment
  justifyContent?: FlexJustify
  flexDirection?: FlexDirection
  inline?: boolean
}

interface Props extends BaseFlexProps {
  mobile?: BaseFlexProps
  tablet?: BaseFlexProps
  className?: string
}

interface WrapperProps {
  flexDirection: FlexDirection
  alignItems: FlexAligment
  justifyContent: FlexJustify
  inline?: boolean
  mobile?: BaseFlexProps
  tablet?: BaseFlexProps
}

export const Flex: React.FC<Props> = ({
  flexDirection = "row",
  alignItems = "flex-start",
  justifyContent = "flex-start",
  inline,
  children,
  mobile,
  tablet,
  className,
}) => {
  return (
    <Wrapper
      flexDirection={flexDirection}
      alignItems={alignItems}
      justifyContent={justifyContent}
      inline={inline}
      mobile={mobile}
      tablet={tablet}
      className={className}
    >
      {children}
    </Wrapper>
  )
}

const getFlexStyle = ({
  inline,
  flexDirection,
  alignItems,
  justifyContent,
}: BaseFlexProps) => {
  return css`
    display: ${inline ? "inline-flex" : "flex"};
    width: ${inline ? "auto" : "100%"};
    flex-direction: ${flexDirection};
    align-items: ${alignItems};
    justify-content: ${justifyContent};
  `
}

const Wrapper = styled.section<WrapperProps>`
  ${({ mobile, tablet, ...defaults }) =>
    getFlexStyle(mobile || tablet || defaults)};

  ${({ theme, mobile, tablet, ...desktop }) =>
    mobile
      ? tablet
        ? css`
            @media (min-width: ${theme.bp.tablet}) {
              ${getFlexStyle(tablet)}
            }
            @media (min-width: ${theme.bp.desktop}) {
              ${getFlexStyle(desktop)}
            }
          `
        : css`
            @media (min-width: ${theme.bp.tablet}) {
              ${getFlexStyle(desktop)}
            }
          `
      : null}
`
